import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';
import classnames from 'classnames';

// styles
import styles from './PdpRespSimilarItemCarousel.scss';

export function PdpRespSimilarItemCarouselComponent({ index, item, isCondensed, onClick }) {
    const { title, pdpURL, isArt } = item;
    const creatorName = get(item, 'creators[0].creator.name');
    // TODO: FINDING-13358: Update this to use srcSet once BE returns masterPath
    const imgSrc = get(item, 'photos[0].versions[0].webPath') || '';

    const containerClass = classnames(styles.itemContainer, {
        [styles.isCondensed]: !!isCondensed,
    });

    return (
        <div className={containerClass} onClick={() => onClick(index)}>
            <a href={pdpURL} className={styles.link}>
                <div className={styles.overlay}>
                    <div className={styles.title}>
                        {isArt && creatorName && `${creatorName} - `}
                        {title}
                    </div>
                </div>
            </a>
            {imgSrc && (
                <div className={styles.imageWrapper}>
                    <img className={styles.image} alt={title} src={imgSrc} />
                </div>
            )}
        </div>
    );
}

PdpRespSimilarItemCarouselComponent.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    isCondensed: PropTypes.bool,
    onClick: PropTypes.func,
};

export const PdpRespSimilarItemCarousel = createFragmentContainer(
    PdpRespSimilarItemCarouselComponent,
    {
        item: graphql`
            fragment PdpRespSimilarItemCarousel_item on Item {
                title
                pdpURL
                isArt
                creators {
                    creator {
                        name
                    }
                }
                photos(limit: 1) {
                    versions {
                        webPath
                    }
                }
                ...LazyImageWrapper_item
            }
        `,
    }
);
